// scheduling/services/bugReports.js
// Bug-report triage + "my reports" service.
//
// Reads + resolves go through the RPRS proxies (api/bug-reports,
// api/bug-reports-resolve) → func-shared-services, the sole writer to
// Feedback.*. ContextApp is server-derived from the app key, and scope=all /
// resolve are gated on ADMIN_EMAILS upstream. The reporter notification on
// resolve is an rprs schedWrite (notify_bug_resolved) — re-exported here so
// the triage UI imports everything bug-related from one module.

import { fetchWithColdStartRetry, notifyBugResolved } from './schedApi';

async function postJson(url, body, label) {
  const r = await fetchWithColdStartRetry(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  }, { label });
  if (!r.ok) {
    const err = await r.text();
    throw new Error(`${label} ${r.status}: ${err}`);
  }
  return r.json();
}

// List (summary) or single detail. filters: { scope:'mine'|'all', status?, id? }
//   → { ok, reports:[…] }  or  { ok, report:{…, context, logs, events } }
export const fetchBugReports = (filters = {}) =>
  postJson('/api/bug-reports', filters, 'bug-reports');

// Resolve/advance one or many. payload: { ids, status, resolutionNote?, addressedInRef? }
//   → { ok, resolved:[{ bugReportId, submittedBy, title, status, resolutionNote }] }
export const resolveBugReports = (payload) =>
  postJson('/api/bug-reports-resolve', payload, 'bug-reports-resolve');

export { notifyBugResolved };
